import type { BalanceSnapshot } from "@capture/shared";
import type { StationTransaction } from "../api/client";
import styles from "./RemittanceStation.module.css";

const VERDICT_TONE: Record<BalanceSnapshot["verdict"], string> = {
  balanced: "ok", imbalanced: "error", indeterminate: "warn",
};

export function TransactionList({
  transactions, activeId, verdictOf, onSelect,
}: {
  transactions: StationTransaction[];
  activeId: string | null;
  verdictOf: (txnId: string) => BalanceSnapshot["verdict"] | null;
  onSelect: (txnId: string) => void;
}) {
  return (
    <nav className={styles.rail} aria-label="Transactions">
      <ul className={styles.railList}>
        {transactions.map((t) => {
          const verdict = t.overriddenAt ? "balanced" : verdictOf(t.id);
          return (
            <li key={t.id}>
              <button
                type="button"
                className={styles.railItem}
                aria-current={t.id === activeId}
                data-active={t.id === activeId}
                onClick={() => onSelect(t.id)}
              >
                <span className={styles.railOrdinal}>Transaction {t.ordinal}</span>
                <span className={styles.railState}>{t.state}</span>
                {verdict && <span className={styles.railVerdict} data-tone={VERDICT_TONE[verdict]}>{verdict}</span>}
                <span className={styles.railDocCount}>{t.documents.length} docs</span>
                {t.duplicateSuspect && (
                  <span className={styles.railDup} title="Possible duplicate deposit" aria-label="Possible duplicate deposit">
                    ⚠ dup
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
